import { render, staticRenderFns } from "./PromotedProjects.vue?vue&type=template&id=5b25e829&scoped=true"
import script from "./PromotedProjects.vue?vue&type=script&lang=js"
export * from "./PromotedProjects.vue?vue&type=script&lang=js"
import style0 from "./PromotedProjects.vue?vue&type=style&index=0&id=5b25e829&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25e829",
  null
  
)

export default component.exports